import { composePaths, createDefaultValue } from "@jsonforms/core";
import { JsonFormsDispatch, withJsonFormsArrayControlProps } from "@jsonforms/react";
import { Button, Icon } from "pepsico-ds";
import { useCallback, useEffect, useMemo } from "react";
import "./_custom_array.scss";

const CustomArrayComponent = (props) => {
  const {
    data,
    addItem,
    removeItems,
    path,
    schema,
    uischema,
    renderers,
    cells,
    enabled,
    label,
  } = props;

  const items = useMemo(() => (Array.isArray(data) ? data : []), [data]);
  const childUiSchema = uischema?.options?.detail;

  const addItemCb = useCallback(
    (p, value) => (addItem ? addItem(p, value) : () => {}),
    [addItem]
  );
  const removeItemsCb = useCallback(
    (p, toDelete) => (removeItems ? removeItems(p, toDelete) : () => {}),
    [removeItems]
  );

  // Ensure one empty row on mount
  useEffect(() => {
    if ((items?.length ?? 0) === 0 && enabled) {
      addItemCb(path, createDefaultValue(schema))();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items?.length, enabled]);

  const isFilled = useMemo(() => {
    if ((items?.length ?? 0) === 0) return false;
    const last = items[items.length - 1] || {};
    const hasFolder = !!(last.folder && String(last.folder).trim().length);
    const hasCodes =
      last.numOfCodes !== undefined &&
      last.numOfCodes !== null &&
      String(last.numOfCodes).toString().length > 0;
    const hasFiles =
      last.numOfFiles !== undefined &&
      last.numOfFiles !== null &&
      String(last.numOfFiles).toString().length > 0;
    return hasFolder && hasCodes && hasFiles;
  }, [items]);

  return (
    <div className="jsonforms-component custom-array-wrapper">
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {items?.map((_, index) => {
          const itemPath = composePaths(path, `${index}`);
          const showDelete = items.length > 1; // hide delete for the initial default row
          return (
            <div key={itemPath} className="custom-array-item">
              <div className="sr-no">{index + 1}</div>
              <div style={{ flex: 1 }}>
                <JsonFormsDispatch
                  path={itemPath}
                  schema={schema}
                  uischema={childUiSchema}
                  renderers={renderers}
                  cells={cells}
                />
              </div>
              {showDelete ? (
                <Icon
                  icon="delete"
                  size="medium"
                  className="delete-icon"
                  data-testid="delete-icon"
                  onClick={removeItemsCb(path, [index])}
                />
              ) : (
                <div style={{ width: 24 }} />
              )}
            </div>
          );
        })}
      </div>

      <div style={{ display: "flex", justifyContent: "center", marginTop: 16 }}>
        <Button
          size="medium"
          disabled={!enabled || !isFilled}
          onClick={addItemCb(path, createDefaultValue(schema))}
        >
          Add {label || "Folder"}
        </Button>
      </div>
    </div>
  );
};

export const CustomArrayControl =
  withJsonFormsArrayControlProps(CustomArrayComponent);
